import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oaosxvesscigzeqztcpx.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hb3N4dmVzc2NpZ3plcXp0Y3B4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1MDU4ODIsImV4cCI6MjA4NzA4MTg4Mn0.YLYsmTdex-3_c0xO7CubbZN_KT1FY3cqLkfNErpdi2I';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
